<template>
  <div class="notification is-danger"> Page Not Accessible. </div>
</template>
